import api from './client';

export const createCustomTag = (uid, tag) => api('/tags', { method: 'POST', body: tag });
export const updateCustomTag = (tagId, tag) => api(`/tags/${tagId}`, { method: 'PATCH', body: tag });
export const deleteCustomTag = tagId => api(`/tags/${tagId}`, { method: 'DELETE' });
export const getCustomTags = () => api('/tags').then(({ tags }) => tags);
